import React from 'react';
import { GetCoinsModal } from './GetCoinsModal';
import { useGetCoins } from '@/contexts/GetCoinsContext';

export const GlobalGetCoinsModal = () => {
  const { isGetCoinsModalOpen, closeGetCoinsModal } = useGetCoins();

  return (
    <GetCoinsModal 
      isOpen={isGetCoinsModalOpen}
      onClose={closeGetCoinsModal}
    />
  );
};

